import React from 'react';
import {
  Stack,
  Tooltip,
  Badge,
} from '@mui/material';
import {
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
} from '@mui/x-data-grid';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';

function ProjectServicesGridToolbar({ project, disabled }) {
  return (
    <Toolbar
      sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
    >
      <Stack direction='row' spacing={1}>
        {/* Left side buttons can go here */}
      </Stack>
      <Stack direction='row' spacing={1}>
        <Tooltip title='Columns'>
          <ColumnsPanelTrigger render={<ToolbarButton />}>
            <ViewColumnIcon fontSize='small' color='brandBlack' />
          </ColumnsPanelTrigger>
        </Tooltip>
        <Tooltip title='Filters'>
          <FilterPanelTrigger
            render={(props, state) => (
              <ToolbarButton {...props}>
                <Badge badgeContent={state.filterCount} variant='dot'>
                  <FilterListIcon fontSize='small' color='brandBlack' />
                </Badge>
              </ToolbarButton>
            )}
          />
        </Tooltip>
      </Stack>
    </Toolbar>
  );
}
export default ProjectServicesGridToolbar;
